import React, { useRef, useState } from 'react'

// Utils
import { OVERLAY_HELPERS } from 'src/constants/navigation'

// Components
import { OverlayPanel } from 'src/Components'
import Content from './Content'
import Header from './Header'

// Styles
import styles from './PhotoPanel.module.scss'

export interface PhotoPanelProps {
  listing: { thumbnailImageFileNames: Array<string> };
}

const PhotoPanel = ({ listing }: PhotoPanelProps) => {
  const overlayRef = useRef(null)
  const [index, setIndex] = useState(1)

  return (
    <OverlayPanel
      className={styles.photoPanel}
      ref={overlayRef}
      back={OVERLAY_HELPERS.listingDetailsPhotos.getOrigin()}
      path={OVERLAY_HELPERS.listingDetailsPhotos.buildPath() || '/not-found'}
      disableAnchor
      title='Listing Photos'
      renderTitle={() => <Header index={index} listing={listing} />}
      render={() => (
        <Content
          imageChange={current => setIndex(current + 1)}
          listing={listing}
          className={undefined}
        />
      )}
    />
  )
}

export default PhotoPanel
